import { Component, Input, OnInit, SimpleChanges } from '@angular/core';

import { PrivateNumbersService } from '../../../core/api/services/private-numbers.service';
import { BaseSelectSearch } from './base/base-select-search.component';
import { BaseSelectSearchModule } from './base/base-select.search.module';

@Component({
    selector: 'private-number-for-statistics-select-search',
    templateUrl: './base/base-select-search-template.html',
    imports: [BaseSelectSearchModule]
})
export class PrivateNumberForStatisticsSelectSearchComponent
  extends BaseSelectSearch
  implements OnInit
{
  @Input() isAdminStats?: boolean;

  constructor(protected currentService: PrivateNumbersService) {
    super();
  }

  initConfig() {
    this.optionValue = 'privateNumber';
    this.optionTitle = 'privateNumber';
    if (!this.label) this.label = 'common.privateNumber';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['organizationId'] && !changes['organizationId']?.firstChange)
      this.getItems();
  }

  getItemsApi() {
    this.currentService
      .privateNumbersGetPrivateNumbersForStatistics({
        IsReturnDescendantPrivateNumbers: this.isAdminStats,
      })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }
}
